module.exports = __webpack_public_path__ + "img/IMG022.a5cf2ee7.jpg";